import axios from "axios";

export const state = {
    department: [{ name: 'Consultation', id: '1' },
        { name: 'Radiology', id: '2' },
        { name: 'Procedure', id: '3' },
        { name: 'Laboratory', id: '4' },
        { name: 'Dental', id: '6' },
        { name: 'Other Services', id: '8' },
        { name: 'Antenatal', id: '7' }
     
    ],
    department_add: [{ name: 'Consultation', id: '1' },
        { name: 'Radiology', id: '2' },
        { name: 'Procedure', id: '3' },
        { name: 'Laboratory', id: '4' },
        { name: 'Dental', id: '6' },
        { name: 'Antenatal', id: '7' },
        { name: 'Other Services', id: '8' },
    ],
    report_filters_departments: [
        { name: 'All', id: '0' },
        { name: 'Consultation', id: '1' },
        { name: 'Radiology', id: '2' },
        { name: 'Procedure', id: '3' },
        { name: 'Laboratory', id: '4' },
        { name: 'Pharmacy', id: '5' },
        { name: 'Dental', id: '6' },
        { name: 'Antenatal', id: '7' },
        { name: 'Other Services', id: '8' }
    ],
    result_types: [
        { name: 'Has Defined Result Options', id: '1' },
        { name: 'Has Undefined Result Options', id: '2' },
        { name: 'Has Machine Based Results', id: '3' },
        { name: 'Has Defined Parameters', id: '4' },
        { name: 'Has Culture and Sensitivity', id: '5' }
    ],
    lab_services: [],
    consultation_services: [],
    radiology_services: [],
    procedure_services: [],
    dental_services: [],
    antenatal_services: [],
    other_services: [],
    lab_categories: [],
    lab_result_options: [],
    inpatient_services: [],
    result_options: [],
    service_status: false,
    cid10data:[]

};
export const getters = {
    departments: state => state.department,
    department_add: state => state.department_add,
    InpatientServices: state => state.inpatient_services.data,
    ReportFiltersDepartments: state => state.report_filters_departments,
    resultTypes: state => state.result_types,
    labServices: state => state.lab_services.data,
    labCategories: state => state.lab_categories.data,
    consultationServices: state => state.consultation_services.data,
    radiologyServices: state => state.radiology_services.data,
    procedureServices: state => state.procedure_services.data,
    dentalServices: state => state.dental_services.data,
    antenatalServices: state => state.antenatal_services.data,
    otherServices: state => state.other_services.data,
    labResultOptions: state => state.lab_result_options.data,
    resultOptions: state => state.result_options,
    ServiceStatus: state => state.service_status,
    Cid10Data: state => state.cid10data
};

export const mutations = {
    SET_INPATIENT_SERVICES:(state, newValue) => state.inpatient_services = newValue,
    SET_LAB_SERVICES:(state, newValue) => state.lab_services = newValue,
    SET_CONSULTATION_SERVICES:(state, newValue) => state.consultation_services = newValue,
    SET_RADIOLOGY_SERVICES:(state, newValue) => state.radiology_services = newValue,
    SET_PROCEDURE_SERVICES:(state, newValue) => state.procedure_services = newValue,
    SET_DENTAL_SERVICES:(state, newValue) => state.dental_services = newValue,
    SET_LAB_CATEGORIES:(state, newValue) => state.lab_categories = newValue,
    SET_ATENATAL_SERVICES:(state, newValue) => state.antenatal_services = newValue,
    SET_OTHER_SERVICES:(state, newValue) => state.other_services = newValue,
    SET_SERVICE_STATUS:(state, newValue) => state.service_status = newValue,
    SET_RESULT_OPTIONS:(state, newValue) => state.lab_result_options = newValue,
    SET_OPTIONS:(state, newValue) => state.result_options = newValue,
    SET_CID10_DATA:(state, newValue) => state.cid10data = newValue,
    ADD_CID10_DATA: (state, newValue) => state.cid10data.push(newValue)
};

export const actions = {
    fetchLabServices({ commit }) {
        axios.get('labservices').then(lb_res => {
            commit('SET_LAB_SERVICES', lb_res.data)
        })
    },
    fetchInpatientServices({ commit }) {
        axios.get('otherservice/8').then(c_res => {
            commit('SET_INPATIENT_SERVICES', c_res.data)
        })
    },
    fetchConsultationServices({ commit }) {
        axios.get('otherservice/1').then(c_res => {
            commit('SET_CONSULTATION_SERVICES', c_res.data)
        })
    },
    fetchRadiologyServices({ commit }) {
        axios.get('otherservice/2').then(r_res => {
            commit('SET_RADIOLOGY_SERVICES', r_res.data)
        })
    },
    fetchProcedureServices({ commit }) {
        axios.get('otherservice/3').then(p_res => {
            commit('SET_PROCEDURE_SERVICES', p_res.data)
        })
    },
    fetchDentalServices({ commit }) {
        axios.get('otherservice/6').then(d_res => {
            commit('SET_DENTAL_SERVICES', d_res.data)
        })
    },
    fetchAntenatalServices({ commit }) {
        axios.get('otherservice/7').then(d_res => {
            commit('SET_ATENATAL_SERVICES', d_res.data)
        })
    },
    fetchOtherServices({ commit }) {
        axios.get('otherservice/8').then(d_res => {
            commit('SET_OTHER_SERVICES', d_res.data)
        })
    },

    saveService({ dispatch, commit }, data) {
        commit('SET_SERVICE_STATUS', true)
        axios.post('other_service', data).then(res => {
            commit('SET_SERVICE_STATUS', false)
            if (res.status == 200) {
                let message = { 'msg': res.data.msg }
                dispatch('notification/success', message, { root: true })
            }
            if (res.status == 202) {
                let message = { 'msg': res.data.msg }
                dispatch('notification/error', message, { root: true })
            }
            dispatch('fetchConsultationServices')
            dispatch('fetchRadiologyServices')
            dispatch('fetchDentalServices')
            dispatch('fetchProcedureServices')
            dispatch('fetchAntenatalServices')
            dispatch('fetchInpatientServices')
        }).catch(() => {
            commit('SET_SERVICE_STATUS', false)
            let message = { 'msg': "Error adding consultation" }
            dispatch('notification/error', message, { root: true })
        });
    },

    updateService({ dispatch }, editData) {
        axios.put(`other_service/${editData.id}`, editData).then(() => {
            dispatch('fetchConsultationServices')
            dispatch('fetchRadiologyServices')
            dispatch('fetchDentalServices')
            dispatch('fetchProcedureServices')
            dispatch('fetchAntenatalServices')
            dispatch('fetchInpatientServices')
        })
    },

    deleteService({ dispatch }, deleteData) {
        axios.delete(`other_service/${deleteData.id}`).then(() => {
            dispatch('fetchConsultationServices')
            dispatch('fetchRadiologyServices')
            dispatch('fetchDentalServices')
            dispatch('fetchProcedureServices')
            dispatch('fetchAntenatalServices')
            dispatch('fetchInpatientServices')
        })
    },

    saveLabService({ dispatch }, data) {
        axios.post('labservices', data).then(() => {
            dispatch('fetchLabServices')
         let message = { 'msg': 'Service saved successfully' }
            dispatch('notification/success', message, { root: true })
        }).catch(() => {
            let message = { 'msg': 'Error saving service' }
            dispatch('notification/error', message, { root: true })
        })
    },


    updateLabService({ dispatch }, labEdit) {
        axios.put(`labservices/${labEdit.id}`, labEdit).then(() => {
            dispatch('fetchLabServices')
         let message = { 'msg': 'Service Updated successfully' }
            dispatch('notification/success', message, { root: true })
        }).catch(() => {
            let message = { 'msg': 'Error updating service' }
            dispatch('notification/error', message, { root: true })
        })
    },

    deleteLabService({ dispatch }, deleteData) {
        axios.delete(`labservices/${deleteData.id}`).then(() => {
            dispatch('fetchLabServices')
         let message = { 'msg': 'Service deleted successfully' }
            dispatch('notification/success', message, { root: true })
        }).catch(() => {
            let message = { 'msg': 'Error deleting service' }
            dispatch('notification/error', message, { root: true })
        })
    },
    saveLabCategory({ dispatch }, data) {
        axios.post('labcategories', data).then(() => {
            dispatch('fetchLabCategories')
            let message = { 'msg': 'Lab Category added successfully' }
            dispatch('notification/success', message, { root: true })
        }).catch(() => {
            let message = { 'msg': 'Error adding Lab Category' }
            dispatch('notification/error', message, { root: true })
        })
    },
    fetchLabCategories({ commit }) {
        axios.get('labcategories').then(res => {
            commit('SET_LAB_CATEGORIES', res.data)
        })
    },
    updateLabCategory({ dispatch }, editData) {
        axios.put(`labcategories/${editData.id}`, editData).then(() => {
            dispatch('fetchLabCategories')
            let message = { 'msg': 'Lab Category edited successfully' }
            dispatch('notification/success', message, { root: true })
        }).catch(() => {
            let message = { 'msg': 'Error editing Lab Category' }
            dispatch('notification/error', message, { root: true })
        })
    },
    deleteLabCategory({ dispatch }, deleteData) {
        axios.delete(`labcategories/${deleteData.id}`).then(() => {
            dispatch('fetchLabCategories')
            let message = { 'msg': 'Lab Category deleted successfully' }
            dispatch('notification/success', message, { root: true })
        }).catch(() => {
            let message = { 'msg': 'Error deleting Lab Category' }
            dispatch('notification/error', message, { root: true })
        })
    },

    matchTestSamples({ commit, dispatch }, payload) {
        commit('SET_SERVICE_STATUS', true)
        axios.post("match_samples", payload).then(resp => {
            commit('SET_SERVICE_STATUS', false)
            commit('SET_LAB_SERVICES', resp.data)
            let message = { 'msg': 'Success! Samples added successfully' }
            dispatch('notification/success', message, { root: true })
        }).catch(() => {
            commit('SET_SERVICE_STATUS', false)
            let message = { 'msg': 'Ops! Samples adding failed' }
            dispatch('notification/error', message, { root: true })
        })
    },

    matchTestConsumable({ commit, dispatch }, payload) {
        commit('SET_SERVICE_STATUS', true)
        axios.post("test_consumables", payload).then(response => {
            dispatch('fetchLabServices')
            commit('SET_SERVICE_STATUS', false)
            let message = { 'msg': response.data.msg }
            dispatch('notification/success', message, { root: true })
        }).catch(() => {
            commit('SET_SERVICE_STATUS', false)
            let message = { 'msg': 'Ops! consumable adding failed' }
            dispatch('notification/error', message, { root: true })
        })
    },

    deleteTestConsumable({ dispatch, commit }, consumable) {
        commit('SET_SERVICE_STATUS', true)
        axios.delete(`test_consumables/${consumable}`).then(response => {
            dispatch('fetchLabServices')
            commit('SET_SERVICE_STATUS', false)
            if (response.status == 200) {
                let message = { 'msg': response.data.msg }
                dispatch('notification/success', message, { root: true })
            } else {
                let message = { 'msg': response.data.msg }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SERVICE_STATUS', false)
            let message = { 'msg': 'Ops! test consumable deleting failed' }
            dispatch('notification/error', message, { root: true })
        })
    },

    fetchResultOptions({ commit }) {
        axios.get('labresultoptions').then(res => {
            commit('SET_RESULT_OPTIONS', res.data)
        })
    },
    fetchOptions({ commit }) {
        axios.get('result_options').then(res => {
            commit('SET_OPTIONS', res.data)
        })
    },
    saveResultOption({ commit, dispatch }, payload) {
        commit('SET_SERVICE_STATUS', true)
        axios.post('labresultoptions', payload).then(response => {
            commit('SET_SERVICE_STATUS', false)
            dispatch('fetchResultOptions')
            dispatch('fetchOptions')
            if (response.status == 200) {
                let message = { 'msg': response.data.msg }
                dispatch('notification/success', message, { root: true })
            } else {
                let message = { 'msg': response.data.msg }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SERVICE_STATUS', false)
            let message = { 'msg': 'Ops! Result option adding failed' }
            dispatch('notification/error', message, { root: true })
        })
    },
    deleteResultOption({ dispatch, commit }, deleteData) {
        commit('SET_SERVICE_STATUS', true)
        axios.delete(`labresultoptions/${deleteData.id}`).then(response => {
            dispatch('fetchResultOptions')
            dispatch('fetchOptions')
            commit('SET_SERVICE_STATUS', false)
            if (response.status == 200) {
                let message = { 'msg': response.data.msg }
                dispatch('notification/success', message, { root: true })
            } else {
                let message = { 'msg': response.data.msg }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SERVICE_STATUS', false)
            let message = { 'msg': 'Ops! Result option deleting failed' }
            dispatch('notification/error', message, { root: true })
        })
    },

    updateResultOption({ dispatch, commit }, payload) {
        commit('SET_SERVICE_STATUS', true)
        axios.put(`labresultoptions/${payload.id}`, payload).then(response => {
            dispatch('fetchResultOptions')
            dispatch('fetchOptions')
            commit('SET_SERVICE_STATUS', false)
            if (response.status == 200) {
                let message = { 'msg': response.data.msg }
                dispatch('notification/success', message, { root: true })
            } else {
                let message = { 'msg': response.data.msg }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SERVICE_STATUS', false)
            let message = { 'msg': 'Ops! Result option updating failed' }
            dispatch('notification/error', message, { root: true })
        })
    },

    fetchCid10Data({ commit }) {
        axios.get('cid10').then(res => {
            commit('SET_CID10_DATA', res.data)
        })
    },
};